import request from '../utils/request.util'

export default {
  getList (params) {
    return request.get('/addresses', { params })
  },
  getTotal (params) {
    return request.get('/addresses/total', { params })
  },
  create (data) {
    return request.post('/addresses', data)
  },
  update (id, data) {
    return request.put(`/addresses/${id}`, data)
  },
  getOne (id) {
    return request.get(`/addresses/${id}`)
  },
  remove (id) {
    return request.delete(`/addresses/${id}`)
  },
  addPermit (params) {
    const {addressId, devices, phone} = params
    return request.post(`/addresses/${addressId}/permit`, { devices, phone })
  },
  removePermit (params) {
    const {addressId, devices, phone} = params
    return request.delete(`/addresses/${addressId}/permit`, {
      data: { devices, phone }
    })
  },
  removeAllPermits (params) {
    const {addressId, phone} = params
    return request.delete(`/addresses/${addressId}/permit-all`, {
      data: { phone }
    })
  },
}
